{
  "en": {
    "subscription": {
      "customers": {
        "announcement": {
          "description": "Receive a notification when new posts are published.",
          "label": "News posts"
        },
        "question": {
          "description": "Receive a notification when new questions are added in the FAQ section.",
          "label": "FAQ"
        }
      },
      "employees": {
        "announcement": {
          "description": "Receive a notification when new posts are published.",
          "label": "News posts"
        },
        "decision": {
          "description": "Receive notifications related to decisions.",
          "label": "Decisions"
        },
        "document": {
          "description": "Receive a notification when new documents are uploaded.",
          "label": "Documents"
        },
        "export": {
          "description": "Receive a notification when exports are generated.",
          "label": "Exports"
        },
        "question": {
          "description": "Receive a notification when new questions are added in the FAQ section.",
          "label": "FAQ"
        },
        "survey": {
          "description": "Receive notifications related to surveys.",
          "label": "Surveys"
        },
        "ticket": {
          "description": "Receive notifications related to conversations.",
          "label": "Conversations"
        },
        "todo": {
          "description": "Receive a notification when you are assigned as the responsible of a task.",
          "label": "Tasks Assignments"
        }
      },
      "labels": {
        "email_preferences": "My Email notification preferences",
        "general_preferences": "My Notification Preferences",
        "receiveEmailNotificationsAbout": "Receive email notifications"
      }
    }
  }
}